/** Google AdSense integration.
 *
 * Configure in /app/frontend/.env:
 *   REACT_APP_ADSENSE_CLIENT=ca-pub-XXXXXXXXXXXXXXXX
 *   REACT_APP_ADSENSE_SLOT=XXXXXXXXXX
 *
 * When either value is empty, the AdBanner renders a subtle house-ad placeholder
 * (so nothing looks broken in dev). In production, once you paste your AdSense
 * credentials, the placeholder is replaced by the live ad automatically.
 */
import { useEffect, useRef } from "react";

const CLIENT = process.env.REACT_APP_ADSENSE_CLIENT || "";
const SLOT = process.env.REACT_APP_ADSENSE_SLOT || "";

let scriptLoaded = false;
function loadAdSense() {
  if (scriptLoaded || !CLIENT) return;
  const s = document.createElement("script");
  s.async = true;
  s.crossOrigin = "anonymous";
  s.src = `https://pagead2.googlesyndication.com/pagead/js/adsbygoogle.js?client=${CLIENT}`;
  document.head.appendChild(s);
  scriptLoaded = true;
}

export function AdBanner({ className = "", format = "auto" }) {
  const ref = useRef(null);

  useEffect(() => {
    if (!CLIENT || !SLOT) return;
    loadAdSense();
    try {
      // eslint-disable-next-line no-unused-expressions
      (window.adsbygoogle = window.adsbygoogle || []).push({});
    } catch (_) {
      /* AdSense not ready yet — harmless in dev */
    }
  }, []);

  if (!CLIENT || !SLOT) {
    return (
      <div
        className={`w-full rounded-md border border-dashed border-carmel-gold/40 bg-carmel-gold/5 px-4 py-3 text-center ${className}`}
        data-testid="ad-placeholder"
      >
        <p className="text-[11px] uppercase tracking-[0.25em] text-carmel-gold">Sponsored</p>
        <p className="text-xs text-carmel-navy/60 mt-1">
          Ad space — configure AdSense to earn per app open.
        </p>
      </div>
    );
  }

  return (
    <ins
      ref={ref}
      className={`adsbygoogle block ${className}`}
      style={{ display: "block" }}
      data-ad-client={CLIENT}
      data-ad-slot={SLOT}
      data-ad-format={format}
      data-full-width-responsive="true"
      data-testid="ad-banner"
    />
  );
}
